import React from "react";
import { TodoContext } from "../TodoContext";

function TodoSearch() {
  /* react hooks 
    const [searchValue, setSearchValue] = React.useState(''); 
  */
  const { searchValue, setSearchValue } = React.useContext(TodoContext);

  const onSearch = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <input
      placeholder="Busca o agrega..."
      className="todo-search w-full my-4 p-2 text-center bg-white text-black focus:outline-violet-500 drop-shadow-md rounded-md placeholder:text-gray-500"
      value={searchValue}
      onChange={onSearch}
    />
  );
}

export { TodoSearch };
